// 百度埋点事件上报
/*
category：要监控的目标的类型名称，通常是同一组目标的名。该项必选。按模块分类、如createOrder/pay/等等

action：用户跟目标交互的行为。该项必选.如‘跳转到协议,增加锁数量、下单等’

opt_label：事件的一些额外信息，通常可以是歌曲的名称、软件的名称、链接的名称等等。该项可选，将此项定义为事件名称，比如跳转到协议。

opt_value：事件的一些数值信息，比如权重、时长、价格等等，在报表中可以看到其平均值等数据。该项可选，此项为需要携带的参数，比如协议版本、类型。

调用：
  ex: this.$bdTarget('createOrder', '跳转到协议')
*/
export default (Vue) => {
  /**
   * @description 百度埋点事件上报
   * @param {String} category 要监控的目标的类型名称
   * @param {String} action 用户跟目标交互的行为
   * @param {String} optLabel 事件的一些额外信息
   * @param {String} optValue 事件的一些数值信息
   * @example this.$bdTarget('createOrder', '跳转到协议')
   *
   */
  const targetEvent = (category, action, optLabel, optValue) => {
    _hmt.push(['_trackEvent', category, action, optLabel, optValue])
  }
  Vue.prototype.$bdTarget = targetEvent
}
